import * as z from "zod";

/** Common input for the 3PL warehouse SLA dashboard RPCs. */
export const threePlDateRangeInput = z.object({
  startDate: z.date(),
  endDate: z.date(),
  returnsCenterId: z.string().optional(),
});
